import { Link } from 'react-router-dom';
import TownShip from './assets/township tours.jpg';
import SafariDayTourImage from './assets/SafariTours.jpg';
import CapePeninsulaImage from './assets/cape-peninsula.jpg';
import CitytourImage from './assets/CityTour.jpg';
import WinelandsImage from './assets/Winelands.jpg';
import SafariMultiDay from './assets/SafariMult.jpg';
import SafariNight from './assets/SafariNight.jpg';
import ParaglidingImage from './assets/Paragliding.jpg';
import ZipliningImage from './assets/ziplining.jpg';
import SharkDivingImage from './assets/Shark Diving.jpg';
import AquilaImage from './assets/Aquila Safari.jpg';
import GardenRouteImage from './assets/Garden Route.png';
import TableMountImage from './assets/Table Mount.png';


function ToursPage() {
  const toursData = [
    {
      id: 'garden-route-tour',
      title: 'The Garden Route Tour',
      description: 'The only way to do the Garden Route is your way. Customize your highlights and activities for an unforgettable personalized journey.',
      image: GardenRouteImage,
      link: '/tours/garden-route'
    },
    {
      id: 'table-mountain-tour',
      title: 'Table Mountain',
      description: 'No trip is complete without a visit to the top. Get panoramic views of the city, ocean, and surrounding peaks.',
      image: TableMountImage,
      link: '/tours/table-mountain'
    },
    {
      id: 'aquila-safari-day',
      title: 'Aquila Safari',
      description: 'Experience the thrill of the "Big 5" (Lion, Leopard, Elephant, Rhino, Buffalo) on a day-trip safari at a private game reserve.',
      image: AquilaImage,
      link: '/tours/aquila-safari'
    },
    {
      id: 'cape-town-city-tour',
      title: 'Cape Town City Tour',
      description: 'Explore the great food, art, history, and nightlife of Africa’s oldest and most exciting city with Ebamba.',
      image: CitytourImage,
      link: '/tours/city-tour'
    },
    {
      id: 'cape-point-peninsula-tour',
      title: 'Cape Point & Peninsula Tour',
      description: 'Our signature tour covers the dramatic cliffs of the Atlantic Seaboard, penguins at Boulders Beach, and culminates at the iconic Cape Point.',
      image: CapePeninsulaImage,
      link: '/tours/cape-peninsula'
    },
    {
      id: 'cape-winelands-tour',
      title: 'Cape Winelands Tour',
      description: 'Enjoy some of the world’s most beautiful scenery – and taste some of the world’s great wines – on our Ebamba Cape Winelands Tours.',
      image: WinelandsImage,
      link: '/tours/cape-winelands'
    },
    {
      id: 'township-tour-cape-town',
      title: 'Township Tour Cape Town',
      description: 'The Cape Town Township tour offers visitors insight into South African culture like no other. Walk in the shoes of most South Africans and see what life is like for them.',
      image: TownShip,
      link: '/tours/township-tour'
    },
    {
      id: 'full-day-safari-cape-town',
      title: 'Full Day Safari Cape Town',
      description: "Sometimes you spot the lion and sometimes a gazelle, keep wandering and you'll come across something worth chasing after with Ebamba.",
      image: SafariDayTourImage,
      link: '/tours/full-day-safari'
    },
    {
      id: 'overnight-safari-cape-town',
      title: 'Overnight Safari Cape Town',
      description: "Embrace the unknown, take the bumpy ride and let the beauty of the wilderness awaken your soul with one of our overnight Safaris.",
      image: SafariNight,
      link: '/tours/overnight-safari'
    },
    {
      id: 'multi-day-safari-cape-town',
      title: 'Multi-Day Safari Cape Town',
      description: "Let the adventure of a multi-day Safari guide you to memories that will stay with you forever!",
      image: SafariMultiDay,
      link: '/tours/multi-day-safari'
    },
    {
      id: 'paragliding-cape-town',
      title: 'Paragliding Cape Town',
      description: 'Experience the most popular adrenaline activity in the city, available all year round.',
      image: ParaglidingImage,
      link: '/tours/paragliding'
    },
    {
      id: 'shark-cage-diving',
      title: 'Shark Cage Diving',
      description: 'A thrilling full-day experience just two hours from Cape Town in Gansbaai, the shark capital.',
      image: SharkDivingImage,
      link: '/tours/shark-cage-diving'
    },
    {
      id: 'ziplining-cape-town',
      title: 'Ziplining Cape Town',
      description: 'Exhilarating ziplining experiences offering stunning panoramic vistas of the city\'s natural beauty.',
      image: ZipliningImage,
      link: '/tours/ziplining'
    }
  ];

  return (
    <section className="tours-section">
      <div className="container">
        <h2>Our Premier Tours and Activities</h2>
        <div className="tour-grid">
          {toursData.map(tour => (
            <div className="tour-card" key={tour.id}>
              <img src={tour.image} alt={tour.title} />
              <h3>{tour.title}</h3>
              <p>{tour.description}</p>
              <Link to={tour.link} className="btn btn-primary" style={{margin: '1rem', display: 'block'}}>
                Find Out More...
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ToursPage;
